import { useState, type PropsWithChildren } from 'react';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';

export function Shell({ children }: PropsWithChildren) {
  const [mobOpen, setMobOpen] = useState(false);

  return (
    <div id="app">
      <Sidebar mobOpen={mobOpen} onClose={() => setMobOpen(false)} />
      <div id="main">
        <TopBar onMenuToggle={() => setMobOpen((o) => !o)} />
        <div id="content">{children}</div>
      </div>
    </div>
  );
}
